import React from 'react';
import PropTypes from 'prop-types'
import { useStore } from "../store";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import request from "../api/request";

const WizardButtons = ({ children }) => {
  const setToken = useStore(state => state.setToken)
  const setTokenFlag = useStore(state => state.setTokenFlag)

  const { executeRecaptcha } = useGoogleReCaptcha();
  const handleReCaptchaVerify = React.useCallback(async () => {
    if (!executeRecaptcha) {
      return;
    }

    const token = await executeRecaptcha('generate');
    setToken(token)
    console.log('Check v3')
    request.post('api/privacy-policy/ui/verify_cap', {
      token: token
    }).then(response => {
      if(response.data.isValid) {
        setTokenFlag(true);
      } else {
        setTokenFlag(false);
      }
    }).catch(error => {
      console.log(error, 'error');
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    handleReCaptchaVerify();
  }, [handleReCaptchaVerify]);

  return (
      <div className='form-wizard-actions float-end'>
        {children}
      </div>
  );
}

WizardButtons.propTypes = {
  children: PropTypes.node.isRequired,
}
export default WizardButtons